import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.PROCESSIMAGE = function (state, payload) {
  state.img_src = payload
}

const state = {
  rows: [],
  row: null,
  img_src: null,
  frameColor: [],
  frameStyle: []
}
const actions = {
  searchFrame: ({commit, state}, condition) => {
    return client.postData({ data: { search: { api: '???', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          SysUtils.showInfo(SysUtils.MESSAGE.RECORD.NO_MATCH)
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  updateRow: ({commit, state}, row) => {
    return client.postData({ data: { save: { api: '???', input: row } } })
      .then((data) => {
        commit('EDIT', row)
        commit('PROCESSIMAGE', data)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0001User cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }) => {
    console.debug('called M0001User search')
    return client.postData({ data: { search: { api: 'M0201CmsPageManagementService.getFile' } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          SysUtils.showInfo(SysUtils.MESSAGE.RECORD.NO_MATCH)
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0001User add')
    commit('EDIT',
      {
        id: null
        // files: {},
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'M0001UserService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0201CmsPageManagementService.deleteFile', input: row } } })
      .then((data) => {
        alert('Delete Successful')
        commit('SAVEFILE', data.delete.output)
      })
  },
  saveFile: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'M0201CmsPageManagementService.saveNewFile', input: row } } })
      .then((data) => {
        commit('SAVEFILE', data.save.output)
      })
  },
  saveFileContent: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'M0201CmsPageManagementService.saveFileContent', input: row } } })
      .then((data) => {
        alert('Content Saved')
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0001User download')
    return client.download({ data: { download: { api: 'M0001UserService.downloadData', input: condition } } })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/PoHWorkDontTouch/Preview.js